export const UNAUTHORIZED = 401;
export const UNPROCESSABLE_ENTITY = 422;